<template>
    <div class="order">
        <div v-if=showPreloader class="order__preloader">
            <div class="spinner" />
        </div>

        <template v-if="!success">
            <slot name="title" />
            <slot name="buttons" v-if="stepCurrent == 1" />
            <div class="order__steps">
                <div :class="['order__steps-item', { active: index + 1 == stepCurrent, complete: index + 1 < stepCurrent }]"
                     :key="index"
                     @click="switchStep(index + 1, false)"
                     v-for="(item, index) in steps"
                >
                    <div class="order__steps-item-num">{{ index + 1 }}</div>
                    <div class="order__steps-item-name">{{ item }}</div>
                </div>
            </div>
            <order-registration
                :mode="mode"
                @next="switchStep(2, true)"
                v-if="stepCurrent == 1"
                :order="finalOrder"
                :order-date.sync="orderDate"
                :order-info.sync="orderInfo"
                :order-temp.sync="orderTemp"
                :nurse.sync="nurse"
                :show-disclaimer-weekend="showDisclaimerWeekend"
                :order-time-limit="orderTimeLimit"
                :slot-status-preloader="slotStatusPreloader"
                :slot-status="checkSlotStatus"
                @checkSlot="checkSlot"
            />
            <order-address
                v-if="stepCurrent == 2"
                :address.sync="address"
                :current-region-code="currentRegionCode"
                :service-area-limitation="serviceAreaLimitation"
                @prev="switchStep(1, false)"
                @next="switchStep(3, true)"
            />
            <order-services
                v-if="stepCurrent == 3"
                :mode="mode"
                :page-code="pageCode"
                :medsi-service-area="address.medsiServiceArea"
                :order-temp.sync="orderTemp"
                :services-list.sync="servicesList"
                :filters="filters"
                :enable-auto-nurse="enableAutoNurse"
                :auto-nurse="autoNurse"
                :nurse.sync="nurse"
                :service-area-limitation="serviceAreaLimitation"
                :services-weekend="servicesWeekend"
                :services-weekend-ids="servicesWeekendIds"
                :current-address="address"
                :order-info="orderInfo"
                :current-region-code="currentRegionCode"
                :price-disclaimer="priceDisclaimer"
                @prev="switchStep(2, false)"
                @next="switchStep(4, true)"
            />
            <order-payment
                :mode="mode"
                @next="submitOrder"
                @prev="switchStep(3, false)"
                v-if="stepCurrent == 4"
                :order="finalOrder"
                :order-date.sync="orderDate"
                :order-info.sync="orderInfo"
                :order-temp.sync="orderTemp"
                :enable-card-payment="enableCardPayment"
                :enable-home-card-payment="enableHomeCardPayment"
                :show-disclaimer-weekend="showDisclaimerWeekend"
                :error-submit="errorSubmit"
                :preloader="paymentPreloader"
            />
            <slot name="doctors" v-if="stepCurrent == 1" />
        </template>
        <template v-else>
            <template v-if="success === 'payed' && payment">
                <h1 class="order__success-title">
                    <template v-if="payment.success">Ваш заказ был <br>успешно оплачен</template>
                    <template v-else>Ошибка</template>
                </h1>
                <div class="order__success-text">
                    <template v-if="success === 'payed' && !payment.success">
                        {{ payment.error }}
                    </template>
                    <template v-else>
                        Заявка принята, с вами свяжется оператор.
                    </template>
                </div>
                <div class="order__success-buttons">
                    <a href="/pnd/" class="button button_dark">Перейти на главную</a>
                    <button class="button button_light order__success-button-phone">
                        <a :href="`tel:${tel}`" :class="`${telClass}`"></a>
                        <span>Позвонить нам</span>
                    </button>
                </div>
            </template>
            <template v-if="success === 'registered'">
                <h1 class="order__success-title order__success-title--registered">Ваш заказ успешно <br>зарегистрирован</h1>
                <div class="order__success-text">Заявка принята, с вами свяжется оператор.</div>
                <div class="order__success-buttons">
                    <a href="/pnd/" class="button button_dark">Перейти на главную</a>
                    <button class="button button_light order__success-button-phone">
                        <a :href="`tel:${tel}`" :class="`${telClass}`"></a>
                        <span>Позвонить нам</span>
                    </button>
                </div>
            </template>
        </template>
        <new-payment-form
            :servicesList="servicesListPopup"
            :currentService="currentService"
            :disable-payment="disablePayment"
            :stub-text="stubText"
        />
    </div>
</template>

<script>
//import OrderAddress from './OrderAddress';
import OrderServices from './OrderServices';
import axios from 'axios';
import OrderRegistration from './OrderRegistration';
import newPaymentForm from "./new-payment-form";
import OrderPayment from './OrderPayment.vue';
import formData from '../assets/js/_formData';

export default {
    name: 'Order',
    props: {
        mode: {
            type: String,
            default: 'pnd',
        },
        currentRegionCode: {
            type: String,
            default: 'moscow',
        },
        pageCode: {
            type: String,
            default: 'help',
        },
        enableAutoNurse: {
            type: Boolean,
            default: true,
        },
        autoNurse: {
            type: Object,
        },
        filters: {
            type: Array,
            required: true,
        },
        telClass: {
            type: String,
            default: '',
        },
        tel: {
            type: String,
            default: '+74957800500',
        },
        enableCardPayment: {
            type: Boolean,
            default: false,
        },
        enableHomeCardPayment: {
            type: Boolean,
            default: false,
        },
        payment: {
            type: Object,
            default: null,
        },
        serviceAreaLimitation: {
            type: Boolean,
            default: false,
        },
        services: {
            type: Object,
            default: () => {}
        },
        servicesWeekend: {
            type: Object,
            default() {
                return {}
            }
        },
        orderTimeLimit: {
            type: Array,
            default() {
                return []
            }
        },
        currentService: {
            type: String,
            default: ''
        },
        servicesListPopup: {
            type: Array,
            default() {
                return [
                    {
                        id: 1221,
                        name: 'Оплата услуг скорой помощи'
                    },
                    {
                        id: 866,
                        name: 'Пополнение депозита (VIP договор)'
                    },
                    {
                        id: 869,
                        name: 'Оплата разовых услуг'
                    }
                ]
            }
        },
        priceDisclaimer: {
            type: String,
            default: '',
        },
        disablePayment: {
            type: String,
            default: '0'
        },
        stubText: {
            type: String,
            default: '<div>Оплата временно недоступна</div>'
        }
    },
    data() {
        return {
            success: '', //'payed' 'registered',
            steps: [
                'Введите данные',
                'Введите адрес',
                'Выберите услугу',
                'Выбор оплаты',
            ],
            stepCurrent: 1,
            address: {},
            servicesList: [],
            orderTemp: [],
            orderWeek: [],
            orderWeekend: [],
            finalOrder: [],
            orderInfo: {
                surname: '',
                name: '',
                patronymic: '',
                gender: '',
                fio: '',
                surnamePatient: '',
                namePatient: '',
                patronymicPatient: '',
                fioPatient: '',
                genderPatient: '',
                birth: '',
                birthPatient: '',
                phone: '',
                phonePatient: '',
                email: '',
                isPatient: true,
                payment: 'cash',
                receiptDate: new Date(),
                file: [],
                conditions: true,
                // для депозита
                // orderDepositСontracts: ['Тест договор 1', 'Тест договор 2', 'Тест договор 3'],
                // orderDepositSelected: '',
                // sumAvalible: 11000 + ' ₽',
                // sumWriteOff: ''
            },
            orderDate: new Date(),
            nurse: {
                adults: null,
                children: null,
                adults_uzi: null,
                children_uzi: null,
            },
            showPreloader: false,
            showDisclaimerWeekend: false,
            hasServicesWeekendInCart: false,
            errorSubmit: '',
            paymentPreloader: false,
            checkSlotStatus: '',
            slotStatusPreloader: false
        }
    },
    methods: {
        getOrderWeekend() {
            // Формируем заказ на выходной день с заменой соответствующих услуг, если необходимо
            const list = [];
            const addedIds = [];
            this.hasServicesWeekendInCart = false;

            this.orderWeek.forEach(item => {
                const id = item.id;
                const newId = this.servicesWeekend[id];
                const currentId = newId ? newId : id;

                if (newId) {
                    this.servicesListWeekend.some(service => {
                        if (service.id == newId) {
                            if (!service.num) service.num = 1;
                            if (!this.hasServicesWeekendInCart) this.hasServicesWeekendInCart = true;

                            if (!service.servicesWeekIds) service.servicesWeekIds = [];
                            if (!service.servicesWeekIds.includes(id)) service.servicesWeekIds.push(id);

                            if (!addedIds.includes(currentId)) {
                                list.push(service);
                                return true;
                            }
                        }
                    });
                } else {
                    list.push(item);
                }
                addedIds.push(currentId);
            });

            this.orderWeekend = list;
        },
        getOrderFinal() {
            // Формируем окончательный заказ в зависимости от дня недели
            const orderDay = new Date(this.orderDate).getDay();

            switch (orderDay) {
                case 6:
                case 0:
                    if (Object.keys(this.servicesWeekend).length && this.hasServicesWeekendInCart) {
                        this.showDisclaimerWeekend = true;
                        this.finalOrder = this.orderWeekend;
                    } else {
                        this.showDisclaimerWeekend = false;
                        this.finalOrder = this.orderWeek;
                    }
                    break;
                default:
                    this.showDisclaimerWeekend = false;
                    this.finalOrder = this.orderWeek;
                    break;
            }
        },
        switchStep(step, allowNext) {
            if (this.stepCurrent === 3) {
                this.getPrices()
            }
            if (step > this.stepCurrent && !allowNext) {
                return;
            } else {
                if (this.stepCurrent === 3 && step < this.stepCurrent) {
                    this.orderDate = new Date();
                }
                this.stepCurrent = step;
                window.scrollTo(0, 0);
            }
        },
        submitOrder() {
            
            let dateForRequest = `${this.orderInfo.receiptDate.getDate().toString().length === 1 ? '0' +  this.orderInfo.receiptDate.getDate() : this.orderInfo.receiptDate.getDate()}.${(this.orderInfo.receiptDate.getMonth()+1).toString().length === 1 ? '0' + (this.orderInfo.receiptDate.getMonth()+1) : (this.orderInfo.receiptDate.getMonth()+1)}.${this.orderInfo.receiptDate.getFullYear()}`;
            let timeForRequest = this.orderInfo.receiptTime ? this.orderInfo.receiptTime.split('-')[0] : '';
            let action = '/local/modules/accord.sberbank/handlers/pnd.php';
            let data = {
                ADDRESS_ROOM: this.address.flat,
                ADDRESS_ENTRANCE: this.address.entrance,
                ADDRESS_FLOOR: this.address.floor,
                ADDRESS_CODE: this.address.intercom,
                ADDRESS_LAT: this.address.coords[0],
                ADDRESS_LON: this.address.coords[1],
                PAGE: this.mode,
                SERVICES: JSON.stringify(this.finalOrder),
                FILTERS: JSON.stringify(this.finalOrder),
                // для депозита
                // COST: this.total - this.orderInfo.sumWriteOff,
                COST: this.total,
                SURNAME: this.orderInfo.surname,
                NAME: this.orderInfo.name,
                PATRONYMIC: this.orderInfo.patronymic,
                GENDER: this.orderInfo.gender,
                FIO: this.orderInfo.surname + ' ' + this.orderInfo.name + ' ' + this.orderInfo.patronymic,
                BIRTHDATE: this.orderInfo.birth,
                PHONE: this.orderInfo.phone,
                EMAIL: this.orderInfo.email,
                ORDERED_TO: dateForRequest + ' ' + timeForRequest,
                PAYMENT_TYPE: this.orderInfo.payment,
                PATIENT_SURNAME: this.orderInfo.surnamePatient,
                PATIENT_NAME: this.orderInfo.namePatient,
                PATIENT_PATRONYMIC: this.orderInfo.patronymicPatient,
                PATIENT_FIO: this.orderInfo.surnamePatient + ' ' + this.orderInfo.namePatient + ' ' + this.orderInfo.patronymicPatient,
                PATIENT_GENDER: this.orderInfo.genderPatient,
                PATIENT_BIRTHDATE: this.orderInfo.birthPatient,
                PATIENT_PHONE: this.orderInfo.phonePatient,
                CURRENT_PAGE: window.location.pathname,
                // для депозита
                // DEPOSIT_SELECTED: this.orderInfo.orderDepositSelected,
                // SUM_WRITE_OFF: this.orderInfo.sumWriteOff
            };

            if (this.orderInfo.isPatient) {
                data['IS_PATIENT'] = true;
            }

            let formData = new FormData();
            Object.keys(data).forEach(key => formData.append(key, data[key]));

            for (let k in this.address.dadataInfo) {
                this.address.dadataInfo[k] !== null ?
                    formData.append(`address[${k}]`, this.address.dadataInfo[k]) :
                    formData.append(`address[${k}]`, "")
            }
            formData.append(`address[request]`, this.address.request)

            if (this.orderInfo.file.length) {
                for (let i = 0; i < this.orderInfo.file.length; i++) {
                    formData.append('FILES[]', this.orderInfo.file[i].file, this.orderInfo.file[i].name)
                }
            }

            this.showPreloader = true;

            let _this = this;
            axios.post(action, formData)
                .then(res => {
                    _this.showPreloader = false;

                    if (res.data.success) {
                        if (res.data.frameUrl) {
                            // _this.success = 'payed';
                            window.location.replace(res.data.frameUrl);
                        } else {
                            _this.success = 'registered';
                        }
                    } else {
                        this.errorSubmit = res.data.error;
                    }
                })
                .catch(err => {
                    console.error(`MEDSI: order error: ${err}`);
                    _this.showPreloader = false;
                    _this.$root.popup.call = false;
                    this.errorSubmit = err;

                    setTimeout(() => {
                        this.errorSubmit = '';
                    }, 10000);
                });
        },
        getPrices() {
            setTimeout(()=>{
                if (!this.orderTemp.length) return

                this.paymentPreloader = true;

                const data = formData(
                    {
                        lastName: this.orderInfo.namePatient ? this.orderInfo.surnamePatient : this.orderInfo.surname,
                        name: this.orderInfo.namePatient ? this.orderInfo.namePatient : this.orderInfo.name,
                        secondName: this.orderInfo.namePatient ? this.orderInfo.patronymicPatient : this.orderInfo.patronymic,
                        birthdate: this.orderInfo.namePatient ? this.orderInfo.birthPatient : this.orderInfo.birth,
                        phone: this.orderInfo.namePatient ? this.orderInfo.phonePatient.replace(/[^0-9]/g, '') : this.orderInfo.phone.replace(/[^0-9]/g, ''),
                        email: this.orderInfo.email,
                        gender: this.orderInfo.namePatient ? this.orderInfo.genderPatient : this.orderInfo.gender,
                        age: this.getAge(this.orderInfo.namePatient ? this.orderInfo.birthPatient : this.orderInfo.birth),
                        address: this.address.request,
                        longitude: this.address.coords[1],
                        latitude: this.address.coords[0],
                        date: this.localeDateCustom(this.orderInfo.receiptDate) + (this.orderInfo.receiptTime ? ' ' + this.orderInfo.receiptTime.slice(0,5) : ''),
                        clientID: '',
                        page: this.pageCode
                    }
                );

                this.orderTemp.forEach(e => {
                    e ? data.append(`services[${e.id}]`, e.price) : ''
                })

                axios({
                    url: '/api/2.0/pndoperator/order/getPrice/',
                    method: 'post',
                    data,
                    headers: {'Content-Type': 'multipart/form-data'}
                }).then(response => {
                    if (response.data.result) {
                        this.pricesByProfile(response.data.data.services);
                    }
                    this.paymentPreloader = false;
                }).catch(error => {
                    console.log(error);
                    this.paymentPreloader = false;
                })
            })
        },
        getAge(birthday) {
            const date = new Date(birthday)
            const timeDiff = Math.abs(new Date() - date);
            const diff = Math.ceil(timeDiff / ((1000 * 3600 * 24)) / 365);
            return diff;
        },
        pricesByProfile(newPrices) {
            for (let service in newPrices) {
                this.orderTemp.forEach(tempService => {
                    service === tempService.id ?
                        tempService.price = newPrices[service] : ''
                })
            }
        },
        getFormatToday(date) {
            let d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [day, month, year].join('.');
        },
        checkSlot(date) {
            const today = new Date();
            this.slotStatusPreloader = true;

            if (date.getDate() === today.getDate() && date.getMonth() === today.getMonth()) {
                this.slotStatusPreloader = false;
            }

            const data = formData({
                date: date,
                birthday: this.orderInfo.namePatient ? this.orderInfo.birthPatient : this.orderInfo.birth
            })

            axios({
                url: '/api/2.0/pndoperator/order/checkSlot/',
                method: 'post',
                data,
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(response => {
                this.slotStatusPreloader = false;
                if (response.data.result) {
                    this.checkSlotStatus = '' // если запись не закрыта, возвращаем пустую строку
                }
                else {
                    this.checkSlotStatus = `Запись на <span>${this.getFormatToday(date)}</span> закрыта`;
                }
            }).catch(error => {
                this.slotStatusPreloader = false;
                console.log(error);
                this.checkSlotStatus = 'Не удается проверить наличие слота';
            })
        },
        canRegistredToday() {
            const localHours = new Date().getHours();
            const date = new Date()

            if (this.orderTimeLimit.length) {
                if (+localHours > +this.orderTimeLimit[1].slice(0, this.orderTimeLimit[1].indexOf(':'))) {
                    this.checkSlotStatus = `Запись на <span>${this.getFormatToday(date)}</span> закрыта`;
                }
                else this.checkSlotStatus = ''
            }
        },
        localeDateCustom(date) {
            function checkLength(num) {
                return num.toString().length === 1 ?
                    '0' + num.toString() : num
            }
            return checkLength(date.getDate()) + '.' + checkLength((+date.getMonth() + 1)) + '.' + date.getFullYear()
        }
    },
    watch: {
        orderTemp: {
            deep: true,
            handler() {
                this.orderWeek = this.orderTemp;
                this.getOrderWeekend();
                this.getOrderFinal();
            }
        },
        orderDate() {
            this.getOrderFinal();
            this.errorSubmit = '';
        }
    },
    computed: {
        servicesWeekendIds() {
            const listWeekendIds = [];

            Object.values(this.servicesWeekend).forEach(id => {
                if (!listWeekendIds.includes(id)) {
                    listWeekendIds.push(id);
                }
            });

            return listWeekendIds;
        },
        servicesListWeekend() {
            // Формируем список услуг на замену в выходные дни (для ускорения поиска)
            const list = [];

            this.servicesList.some(service => {
                if (this.servicesWeekendIds.includes(service.id)) {
                    list.push(service);
                    if (list.length === this.servicesWeekendIds.length) return true;
                }
            });

            return list;
        },
        addressString() {
            return (Object.keys(this.address).length) ?
                `${this.address.request}, ${this.address.entrance ? 'подъезд ' + this.address.entrance + ',' : ''} ${this.address.flat ? 'кв ' + this.address.flat + ',' : ''} ${this.address.floor ? 'этаж ' + this.address.floor + ',' : ''} ${this.address.intercom ? 'домофн ' + this.address.intercom + ',' : ''}` :
                '';
        },
        total() {
            return this.finalOrder.length ? this.finalOrder.reduce(function (acc, obj) {
                return acc + obj.price * obj.num
            }, 0) : 0;
        }
    },
    components: {
        OrderAddress: () => import("./OrderAddress"),
        OrderServices,
        OrderRegistration,
        newPaymentForm,
        OrderPayment
    },
    created() {
        if (window.location.search.indexOf('payment-success') !== -1) {
            this.success = 'payed';
        }
        if (window.location.search.indexOf('reg-success') !== -1) {
            this.success = 'registered';
        }
    },
    mounted() {
        this.canRegistredToday();
        document.getElementById("app").tabIndex = 1
    },
}
</script>

<style lang="scss">
@import "../../scss/base/include";

.order {
    &__preloader {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 171, 160, 0.1);
        z-index: 1000;
    }

    &__steps {
        margin-bottom: 60px;
        display: flex;
        @include tablet {
            margin-bottom: 40px;
        }
        @include mobile {
            margin-bottom: 22px;
        }

        &-item {
            position: relative;
            -webkit-tap-highlight-color: transparent;

            &:not(:last-child) {
                .order__steps-item-num {
                    margin-right: 160px;
                    @include tablet {
                        margin-right: 75px;
                    }
                    @include mobile {
                        margin-right: 60px;
                    }

                    &::after {
                        content: '';
                        position: absolute;
                        height: 1px;
                        width: 120px;
                        left: 100%;
                        margin-left: 20px;
                        top: 50%;
                        background-color: $border2;
                        @include tablet {
                            width: 40px;
                        }
                        @include mobile {
                            margin-left: 10px;
                        }
                    }
                }
            }

            &.complete {
                cursor: pointer;

                &:hover {
                    .order__steps-item-name {
                        &::after {
                            content: '';
                            width: 100%;
                        }
                    }
                }
            }

            &-num {
                position: relative;
                width: 56px;
                height: 56px;
                line-height: 60px;
                text-align: center;
                font-weight: 500;
                font-size: 24px;
                border-radius: 20px 5px;
                color: $gray;
                background: rgba(125, 121, 135, 0.1);
                margin-bottom: 8px;
                @include tablet {
                    width: 44px;
                    height: 44px;
                    font-size: 18px;
                    line-height: 45px;
                    margin-bottom: 6px;
                }
                @include mobile {
                    width: 33.5px;
                    height: 33.5px;
                    line-height: 34px;
                    border-radius: 15px 5px;
                }

                .active & {
                    background-color: $accent;
                    color: $white-true;
                }

                .complete & {
                    background: rgba(0, 171, 170, 0.2);
                    color: $accent;
                }
            }

            &-name {
                font-size: 16px;
                line-height: 32px;
                display: inline-block;
                position: relative;
                @include tablet {
                    font-size: 14px;
                    line-height: 112.8%;
                    max-width: 70px;
                    color: $gray2;
                }

                &::after {
                    content: '';
                    position: absolute;
                    height: 1px;
                    width: 0;
                    left: 0;
                    bottom: 0;
                    background-color: $accent;
                    transition: width ease 0.3s, opacity 3s;
                }
            }
        }
    }

    &-step {
        margin: 0 -80px;
        padding: 40px 80px 58px;
        box-shadow: 10px 14px 50px rgba(229, 233, 246, 0.8);
        border-radius: 20px;
        background-color: $white-true;
        position: relative;
        @include tablet {
            margin: 0 -34px;
            padding: 18px 32px 48px;
        }
        @include mobile {
            margin: 0;
            padding: 0;
            box-shadow: none;
        }

        &__title {
            font-weight: 500;
            font-size: 24px;
            line-height: 29px;
            @include tablet {
                font-size: 18px;
                line-height: 22px;
            }
            @include mobile {
                font-size: 16px;
                line-height: 23px;
            }
        }
    }

    &__success {
        &-title {
            margin-bottom: 43px;
            @include tablet {
                font-size: 30px;
                line-height: 33px;
                margin-bottom: 34px;
            }
            @include mobile {
                font-weight: 500;
                font-size: 21px;
                line-height: 120%;
                margin-bottom: 25px;
                br {
                    display: none;
                }
            }

            &--registered {
                margin-bottom: 21px;
            }
        }

        &-text {
            font-size: 14px;
            max-width: 490px;
            line-height: 151.8%;
            margin-bottom: 25px;
            color: $gray;
            @include tablet {
                max-width: 360px;
            }
        }

        &-buttons {
            display: flex;
            margin-bottom: 100px;
            @include tablet {
                display: block;
                margin-top: 0px;
                margin-bottom: 40px;
            }
            @include mobile {
                margin-bottom: 30px;
            }

            .button {
                width: 213px;
                display: block;
                margin-right: 20px;
                line-height: 50px;
                padding: 0 20px;
                text-align: center;
                @include tablet {
                    &:not(:last-child) {
                        margin-bottom: 16px;
                    }
                    width: 232px;
                    height: 50px;
                }
                @include mobile {
                    width: 100%;
                    &:not(:last-child) {
                        margin-bottom: 8px;
                    }
                }

                &_dark {
                    @include tablet-min {
                        width: 256px;
                    }
                }

            }
        }

        &-button-phone {
            position: relative;

            a {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 1;
                color: transparent;
            }
        }
    }

    .container {
        padding: 0;
    }
}
</style>
